function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import BasicUtils from "../../utils/basic-utils";
import Icon from "../elements/icon";
import Button from "../elements/button";
var MAX_VISIBLE = 5;
var NUM_CONTROL = 3;
var PLACEHOLDER = "...";

var Pagination = /*#__PURE__*/function (_React$Component) {
  _inherits(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination() {
    var _this;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handlePageChange", function (page) {
      if (!_.isNumber(page)) {
        return;
      }

      page = _this.toValidPage(page);

      if (page !== _this.props.page) {
        return typeof _this.props.onChange === "function" ? _this.props.onChange(page) : undefined;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toValidPage", function (page) {
      page = BasicUtils.toNumber(page);
      page = Math.max(page, 1);
      return page = Math.min(page, _this.toValidTotal(_this.props.total));
    });

    _defineProperty(_assertThisInitialized(_this), "toValidTotal", function (total) {
      return total = Math.max(1, Math.ceil(total));
    });

    _defineProperty(_assertThisInitialized(_this), "getVisiblePages", function () {
      if (_this.props.total <= MAX_VISIBLE) {
        return _.range(1, _this.props.total + 1);
      } else if (_this.props.page < NUM_CONTROL) {
        return _.range(1, MAX_VISIBLE + 1);
      } else {
        var max_value = Math.min(_this.props.page + NUM_CONTROL, Math.ceil(_this.props.total)) + 1;
        var min_value = max_value - NUM_CONTROL - 1;
        return _.flatten([1, PLACEHOLDER, _.range(min_value, max_value)]);
      }
    });

    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.page || !this.props.total) {
        return null;
      }

      var page = this.toValidPage(this.props.page);
      var total = this.toValidTotal(this.props.total);

      if (total === 1) {
        return null;
      }

      var visible_pages = this.getVisiblePages();

      var has_placeholder = _.contains(visible_pages, PLACEHOLDER);

      var activeStyle = {
        backgroundColor: this.props.color,
        borderColor: this.props.color
      };
      return /*#__PURE__*/React.createElement("ul", {
        className: classNames("et--pagination", this.props.className)
      }, /*#__PURE__*/React.createElement("li", {
        className: "et--pagination--item"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: page === 1,
        type: "simple",
        label: "Previous Page",
        className: "et--pagination--prev",
        onClick: function onClick() {
          return _this2.handlePageChange(page - 1);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "chevron-left"
      }))), _.map(visible_pages, function (num) {
        return /*#__PURE__*/React.createElement("li", {
          key: num,
          className: classNames("et--pagination--item", {
            "et--pagination--placeholder": num === PLACEHOLDER,
            "et--pagination--initial": has_placeholder && num === 1,
            "et--pagination--first": num === 1 || has_placeholder && num === _this2.props.page,
            "et--pagination--last": num === _.last(visible_pages),
            "is-active": _this2.props.page === num
          }),
          onClick: function onClick() {
            return _this2.handlePageChange(num);
          },
          style: _this2.props.page === num ? activeStyle : undefined
        }, num);
      }), /*#__PURE__*/React.createElement("li", {
        className: "et--pagination--item"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: page === total,
        type: "simple",
        label: "Next Page",
        className: "et--pagination--next",
        onClick: function onClick() {
          return _this2.handlePageChange(page + 1);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "chevron-right"
      }))));
    }
  }]);

  return Pagination;
}(React.Component);

_defineProperty(Pagination, "displayName", "Pagination");

_defineProperty(Pagination, "propTypes", {
  page: PropTypes.number,
  total: PropTypes.number,
  // total number of pages
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string
});

export { Pagination as default };